import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { modal } from "commonAssets/js/helpers";
import { i18n } from "commonAssets/js/constants";
import formDefault from "../../docs/formDefault.json";

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    // Override claim_contact_information to filter out country field and add submit button
    claim_contact_information(params) {
        // Filter out country field from contact_information array
        const modifiedParams = {
            ...params,
            contact_information: params.contact_information.filter(field => field.name !== 'country')
        };
        
        // Get the parent contact information section with filtered params
        const contactSection = super.claim_contact_information(modifiedParams);
        
        // Create submit button wrapper and add it to contact section
        const buttonWrapper = document.createElement('div');
        buttonWrapper.className = 'text-center mt-4 mb-3';
        
        const submitButton = document.createElement('input');
        submitButton.type = 'submit';
        submitButton.id = 'submit-claim';
        submitButton.className = 'btn btn-primary btn-lg';
        submitButton.value = 'Submit';
        
        buttonWrapper.appendChild(submitButton);
        contactSection.appendChild(buttonWrapper);
        
        return contactSection;
    }

    // Override claim_certification to return empty div since we moved submit button
    claim_certification(params) {
        // Return empty div instead of certification section
        return document.createElement('div');
    }

    // Override setup_country_field_toggle to do nothing since we filtered out the country field
    setup_country_field_toggle() {
        // Country field has been filtered out, so no setup needed
        return;
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    format_claim_data(claim) {
        super.format_claim_data(claim);

        const commPrefInputs = Array.from(
            document.querySelectorAll('input[name="communication_preferences"]')
        );

        if (commPrefInputs.length) {
            const checked = commPrefInputs.find((input) => input.checked);

            if (!checked) {
                claim.flags.valid = false;
                modal(
                    i18n.getTranslation("error"),
                    "Please select your communication preferences before submitting."
                );
                return;
            }

            claim.data.contact["Communication Preferences"] = checked.value;
        }
    }
}
